module.exports = __webpack_public_path__ + "img/rachel.7bd1d96c.png";